'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serialize = undefined;

var _jsBase = require('js-base64');

var serialize = exports.serialize = function serialize(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _jsBase.Base64.encode(JSON.stringify({ name: name, params: params }));
};


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/util.js
// module id = 103
// module chunks = 0